
import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';

import { environment } from './environments/environment';
import { WarningsService } from './app/core/services/warnings.service';
import { DataAccessService } from './app/core/services/data-access.service';
import { UploadService } from './app/core/services/upload-service';
import { CookieService } from 'ngx-cookie-service';
import { LoaderService } from './app/core/services/loader.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LoaderInterceptor } from './app/core/interceptors/loader-interceptor.service';
import { DateAdapter, MAT_DATE_FORMATS, MatNativeDateModule, NativeDateModule } from '@angular/material/core';
import { AppDateAdapter, APP_DATE_FORMATS } from './app/format-datepicker';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { provideCharts, withDefaultRegisterables, BaseChartDirective } from 'ng2-charts';
import { MAT_SELECT_CONFIG, MatSelectModule } from '@angular/material/select';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withRouterConfig } from '@angular/router';
import { routes } from './app/app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatMenuModule } from '@angular/material/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatChipsModule } from '@angular/material/chips';
import { AppComponent } from './app/app.component';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),provideRouter(routes, withRouterConfig({ onSameUrlNavigation: 'reload' })),
        importProvidersFrom(DragDropModule, BrowserModule, MatButtonModule, MatButtonToggleModule, MatToolbarModule, MatIconModule, MatFormFieldModule, MatInputModule, MatSidenavModule, MatListModule, MatCardModule, MatGridListModule, MatTabsModule, MatTableModule, MatSelectModule, MatTooltipModule, MatCheckboxModule, MatDialogModule, MatDatepickerModule, MatNativeDateModule, MatAutocompleteModule, FormsModule, ReactiveFormsModule, BaseChartDirective, MatBadgeModule, MatPaginatorModule, MatSortModule, MatMenuModule, MatExpansionModule, MatRadioModule, MatProgressBarModule, MatProgressSpinnerModule, NgxMatSelectSearchModule, NativeDateModule, MatChipsModule),
        WarningsService,
        DataAccessService,
        UploadService,
        CookieService,
        LoaderService,
        { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
        { provide: DateAdapter, useClass: AppDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        provideHttpClient(withInterceptorsFromDi()),
        provideCharts(withDefaultRegisterables()),
        { provide: MAT_SELECT_CONFIG, useValue: { hideSingleSelectionIndicator: "true" } },
        { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } }, // wymagane przez użycie Swal do wyświetlania popupów (bez tego CDK 21 (Material) używa "popover='manual'" i przykrywa tym wszystko)
        provideAnimations(),
    ]
})
  .catch(err => console.error(err));
